import React from 'react';

function Privacy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-extrabold text-slate-900 dark:text-white mb-8">Privacy Policy</h1>
      <div className="prose dark:prose-invert max-w-none text-slate-600 dark:text-slate-300">
        <p className="mb-4">Last updated: October 2026</p>
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">1. Introduction</h2>
        <p className="mb-4">Welcome to JobBoard. We are committed to protecting your personal information and your right to privacy.</p>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">2. Information We Collect</h2>
        <p className="mb-4">We collect personal information that you voluntarily provide to us when you register on the website, express an interest in obtaining information about us or our products and services.</p>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">3. How We Use Your Information</h2>
        <p className="mb-4">We use personal information collected via our website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations.</p>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">4. Contact Us</h2>
        <p className="mb-4">If you have questions or comments about this notice, you may email us at privacy@jobboard.com.</p>
      </div>
    </div>
  );
}

export default Privacy;
